import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Shell from "./components/Shell";
import Landing from "./pages/Landing";
import Home from "./pages/Home";
import { PublicCalculators, PublicCharts } from "./pages/Tools";
import Today from "./pages/Today";
import Journal from "./pages/Journal";
import Behaviour from "./pages/Behaviour";
import Accounts from "./pages/Accounts";
import Ledger from "./pages/Ledger";
import Analytics from "./pages/Analytics";
import Risk from "./pages/Risk";
import Calculators from "./pages/Calculators";
import Strategies from "./pages/Strategies";
import Education, { CourseDetail } from "./pages/Education";
import Progression from "./pages/Progression";
import Admin from "./pages/Admin";
import Charts from "./pages/Charts";
import Help from "./pages/Help";
import Security from "./pages/Security";
import { VerifyEmail, ForgotPassword, ResetPassword } from "./pages/AuthExtras";
import { Execution, Portfolio, Research, Mentor, Market } from "./pages/Modules";
import CoachPage from "./pages/CoachPage";
import Billing, { PaymentSuccess } from "./pages/Billing";
import Onboarding, { PublicOnboard } from "./pages/Onboarding";
import Manager, { ClientPortal } from "./pages/Manager";
import { Flagged } from "./components/Flagged";
import Legal from "./pages/Legal";
import { CookieConsent } from "./components/CookieConsent";
import PropFirm, { Referrals } from "./pages/PropFirm";
import Replay, { Profile, PublicProfile } from "./pages/Replay";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="empty" style={{ margin: 40 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user) return <Navigate to="/today" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#1e212a", border: "1px solid #33353e", color: "#f7f6f2" } }} />
      <BrowserRouter>
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Public><Home /></Public>} />
          <Route path="/login" element={<Public><Landing /></Public>} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/tools/calculators" element={<PublicCalculators />} />
          <Route path="/tools/charts" element={<PublicCharts />} />
          <Route path="/t/:slug" element={<PublicProfile />} />
          <Route path="/onboard/:slug" element={<Flagged flag="FEATURE_MONEY_MANAGER"><PublicOnboard /></Flagged>} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/legal" element={<Navigate to="/legal/terms" replace />} />
          <Route element={<Protected><Shell /></Protected>}>
            <Route path="/today" element={<Today />} />
            <Route path="/journal" element={<Journal />} />
            <Route path="/security" element={<Security />} />
            <Route path="/behaviour" element={<Behaviour />} />
            <Route path="/coach" element={<CoachPage />} />
            <Route path="/analyst" element={<Navigate to="/coach" replace />} />
            <Route path="/accounts" element={<Accounts />} />
            <Route path="/ledger" element={<Ledger />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/execution" element={<Execution />} />
            <Route path="/risk" element={<Risk />} />
            <Route path="/calc" element={<Calculators />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/strategies" element={<Strategies />} />
            <Route path="/research" element={<Research />} />
            <Route path="/charts" element={<Charts />} />
            <Route path="/education" element={<Education />} />
            <Route path="/education/:id" element={<CourseDetail />} />
            <Route path="/progression" element={<Progression />} />
            <Route path="/mentor" element={<Mentor />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/market" element={<Flagged flag="FEATURE_MARKETPLACE"><Market /></Flagged>} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/help" element={<Help />} />
            <Route path="/manager" element={<Flagged flag="FEATURE_MONEY_MANAGER"><Manager /></Flagged>} />
            <Route path="/onboarding" element={<Flagged flag="FEATURE_MONEY_MANAGER"><Onboarding /></Flagged>} />
            <Route path="/portal" element={<Flagged flag="FEATURE_MONEY_MANAGER"><ClientPortal /></Flagged>} />
            <Route path="/propfirm" element={<PropFirm />} />
            <Route path="/review" element={<Navigate to="/coach" replace />} />
            <Route path="/referrals" element={<Referrals />} />
            <Route path="/replay" element={<Replay />} />
            <Route path="*" element={<Navigate to="/today" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
